import React, { useEffect } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useUserInvitationData } from 'src/core/graphql/hooks'

const AccountInvitationVerification = ({
   email,
   invitationCode,
   onContinue,
   onError,
   targetType,
   targetId
}) => {
   const { userInvitationData, error, loading } = useUserInvitationData({
      invitationCode,
      userEmail: email
   })

   useEffect(() => {
      if (!loading) {
         if (error) {
            onError(error)
         } else {
            onContinue(userInvitationData)
         }
      }
   }, [loading])

   return (
      <View width="100%" height="100%">
         <Text size="3[a-d] 3[e-f]" color="#666">
            Verifying Invitation...
         </Text>
      </View>
   )
}

AccountInvitationVerification.propTypes = {
   email: PropTypes.string.isRequired,
   invitationCode: PropTypes.string.isRequired,
   onContinue: PropTypes.func.isRequired,
   onError: PropTypes.func.isRequired,
   targetType: PropTypes.string.isRequired,
   targetId: PropTypes.string
}

AccountInvitationVerification.defaultProps = {
   targetId: undefined
}

export default AccountInvitationVerification
